import type { CaseForPharmacy } from "@omony/domain";
import { Badge, Button } from "@omony/ui";
import { MonitorUp } from "lucide-react";
import { useConsole } from "../context.js";
import { VideoSlot } from "../../shared/video.js";
import { StepFrame, useT } from "./common.js";
import styles from "./flow.module.css";
import { VitalsPanel } from "./VitalsPanel.js";

/** Videogespräch (A17): eingebettet; am Kiosk Übergabe in den Patientenmodus */
export function VideoStep({ c }: { c: CaseForPharmacy }) {
  const t = useT();
  const { lock } = useConsole();
  return (
    <StepFrame
      eyebrow={t("console.step.video")}
      title={
        c.doctor ? t("console.video.withDoctor", { name: c.doctor.displayName }) : t("console.video.title")
      }
      lead={t(c.status === "in_behandlung" ? "console.video.leadActive" : "console.video.leadAccepted")}
    >
      <div className={styles.videoLayout}>
        <div className={styles.videoArea}>
          <VideoSlot caseId={c.id} className={styles.videoSlot} />
          <div className={styles.actions}>
            <Badge tone={c.status === "in_behandlung" ? "success" : "warning"}>
              {t(`case.status.${c.status}`)}
            </Badge>
            {c.doctor?.specialty ? <span className={styles.small}>{c.doctor.specialty}</span> : null}
            <span className={styles.spacer} />
            {lock ? (
              <Button variant="secondary" icon={<MonitorUp />} onPress={lock}>
                {t("console.video.patientMode")}
              </Button>
            ) : null}
          </div>
        </div>
        <VitalsPanel c={c} />
      </div>
    </StepFrame>
  );
}
